import store from 'store2';
import { combineReducers } from 'redux';
import getApiReducer from '../../../../common/utils/getApiReducer';
import {
  CREATE_SESSION,
  GET_MOVEMENT_SPECIALIST_PROFILES,
  SET_ACTIVE_MOVEMENT_SPECIALIST_ID,
  SET_USER_LOCATION,
  SET_USER_LOCATION_LOADING,
} from './actions';

const activeMovementSpecialistId = (state = null, action) => {
  if (action.type === SET_ACTIVE_MOVEMENT_SPECIALIST_ID) {
    return action.id;
  }

  if (action.type === `${GET_MOVEMENT_SPECIALIST_PROFILES}_REQUEST`) {
    return null;
  }

  return state;
};

const getLocationFromStore = () => {
  const location = store.get('location');

  if (location) {
    return Object.assign({ loaded: true, loading: false }, location);
  }

  return { loaded: false };
};

const profilesReducer = getApiReducer(GET_MOVEMENT_SPECIALIST_PROFILES);
const profiles = (state, action) => {
  let newState = profilesReducer(state, action);

  if (action.type === `${GET_MOVEMENT_SPECIALIST_PROFILES}_SUCCESS`) {
    if (!newState.get('firstLoadComplete')) {
      return newState.set('firstLoadComplete', true);
    }
  }

  return newState;
};

const userLocation = (state = getLocationFromStore(), action) => {
  if (action.type === SET_USER_LOCATION_LOADING) {
    return {
      loaded: false,
      loading: true,
    };
  }

  if (action.type === SET_USER_LOCATION) {
    if (action.error) {
      return {
        loaded: true,
        loading: false,
      };
    } else if (action.location) {
      store.set('location', {
        latitude: action.location.latitude,
        longitude: action.location.longitude,
      });

      return {
        latitude: action.location.latitude,
        longitude: action.location.longitude,
        loaded: true,
        loading: false,
      };
    }
  }

  return state;
};

export default combineReducers({
  activeMovementSpecialistId,
  profiles,
  session: getApiReducer(CREATE_SESSION),
  userLocation,
});



// WEBPACK FOOTER //
// ./src/subscription/coaching/movement-specialists/redux/reducers.js